export default "dist/images/block-pricing-box-sectioned.6bfcd8a.png";